import { useCallback, useEffect, useMemo, useState } from "react";

import { getAllCustomers } from "V2.0/services/customerService";

/**
 * Get all customers Profile associated with the particular whitelabel owner
 */

export default function useCustomerProfiles(companyId) {
  const [customerProfiles, setCustomerProfiles] = useState({
    data: [],
    isLoading: true,
  });

  const fetchCustomerProfiles = useCallback(async () => {
    setCustomerProfiles((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    try {
      const response = await getAllCustomers({ companyId });

      if (response.status === 200) {
        setCustomerProfiles({
          isLoading: false,
          data: response.data,
        });
      }
    } catch (e) {
      setCustomerProfiles((prevState) => {
        return {
          ...prevState,
          isLoading: false,
        };
      });
    }
  }, [companyId]);

  useEffect(() => {
    if (companyId) {
      fetchCustomerProfiles();
    }
  }, [companyId]);

  const value = useMemo(() => {
    return {
      customerProfiles: customerProfiles.data,
      isCustomerProfilesLoading: customerProfiles.isLoading,
      fetchCustomerProfiles,
    };
  }, [customerProfiles, fetchCustomerProfiles]);

  return value;
}
